import { useTranslation } from 'react-i18next';
import inboxDarkImage from 'assets/images/assist/inbox-dark.png';
import inboxLightImage from 'assets/images/assist/inbox-light.png';
import {
  CardDescription,
  CardTitle,
  InboxColumn,
  InboxImage,
  InboxRow,
  InboxVisual,
  Overline,
  SectionHeader,
  SectionHeading,
  SectionInner,
  WhiteSection,
} from '../HostfullyAssistMarketing.styles';

const InboxSection = () => {
  const { t } = useTranslation();

  return (
    <WhiteSection data-testid="assist-inbox">
      <SectionInner>
        <SectionHeader>
          <Overline>
            {t('pageHostfullyAssist.marketing.inbox.overline')}
          </Overline>
          <SectionHeading>
            {t('pageHostfullyAssist.marketing.inbox.headline')}
          </SectionHeading>
        </SectionHeader>
        <InboxRow>
          <InboxColumn>
            <CardTitle>
              {t('pageHostfullyAssist.marketing.inbox.light.title')}
            </CardTitle>
            <CardDescription>
              {t('pageHostfullyAssist.marketing.inbox.light.description')}
            </CardDescription>
            <InboxVisual>
              <InboxImage
                src={inboxLightImage}
                alt={t('pageHostfullyAssist.marketing.inbox.light.imageAlt')}
                data-testid="assist-inbox-image-light"
              />
            </InboxVisual>
          </InboxColumn>
          <InboxColumn>
            <CardTitle>
              {t('pageHostfullyAssist.marketing.inbox.dark.title')}
            </CardTitle>
            <CardDescription>
              {t('pageHostfullyAssist.marketing.inbox.dark.description')}
            </CardDescription>
            <InboxVisual>
              <InboxImage
                src={inboxDarkImage}
                alt={t('pageHostfullyAssist.marketing.inbox.dark.imageAlt')}
                data-testid="assist-inbox-image-dark"
              />
            </InboxVisual>
          </InboxColumn>
        </InboxRow>
      </SectionInner>
    </WhiteSection>
  );
};

export default InboxSection;
